import { atom } from 'jotai';
import { toObject } from '@/utils/object';
import { pitchZonesToCoords } from '@/utils/pitchZonesToCoords';
import { filtersAtom } from './filter';

export const selectedPitchFilterCoordsAtom = atom(get => {
  const { pitchStartZones, pitchEndZones } = get(filtersAtom);
  const startCoords = pitchZonesToCoords(pitchStartZones);
  const endCoords = pitchZonesToCoords(pitchEndZones);

  return {
    ...toObject('event.start', startCoords),
    ...toObject('event.end', endCoords),
  };
});
